// extracted by mini-css-extract-plugin
export default {"spinnerWrapper":"oJLo0q76"};